import { useState, useEffect } from 'react';

interface StickyAddToCartProps {
  productName: string;
  price: number;
  onAddToCart: () => void;
}

export default function StickyAddToCart({ productName, price, onAddToCart }: StickyAddToCartProps) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show sticky bar after scrolling 800px
      setIsVisible(window.scrollY > 800);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-black/95 backdrop-blur-lg border-t border-white/10 z-50 animate-slide-up">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between gap-4">
          <div className="flex-1">
            <h3 className="text-white font-bold truncate">{productName}</h3>
            <p className="text-white/60 text-sm">${price}</p>
          </div>
          <button
            onClick={onAddToCart}
            className="bg-white text-black px-8 py-3 rounded-lg font-bold uppercase tracking-wider hover:bg-white/90 transition-colors whitespace-nowrap"
          >
            <span className="flex items-center gap-2">
              <i className="ri-shopping-bag-line text-lg"></i>
              Add to Cart
            </span>
          </button>
        </div>
      </div>
    </div>
  );
}